import { useInfiniteQuery } from '@tanstack/react-query';

import { isMobile as isMobileHelper } from 'helpers';
import { getOrders } from 'services';

export const useOrders = () => {
  const isMobile = isMobileHelper();
  const ordersAmountToShow = isMobile ? 4 : 12;

  return {
    ...useInfiniteQuery(
      ['orders'],
      ({ pageParam }) =>
        getOrders({ queryKey: ['orders'], pageParam, meta: { limit: ordersAmountToShow } }),
      {
        staleTime: 2 * 60 * 1000,
        refetchOnWindowFocus: false,
        getNextPageParam: (lastPage) => {
          const nextPage = lastPage.pagination.currentPage + 1;
          return lastPage.pagination.hasMorePages ? nextPage : undefined;
        },
      }
    ),
  };
};
